import { defineNuxtPlugin, useRouter } from 'nuxt/app'
import { ODOSCOPE_ROUTE_SLICE_PAYLOAD_KEY } from '#layers/base/utils/odoscopeStateKey'

export default defineNuxtPlugin((nuxtApp) => {
  const { showPerformanceModule } = useExperiments()
  const { get, hydrateNuxtCaches, has, prefetch } = usePrefetchedData()

  const mergePrefetchedOdoscopeSlices = (url: string) => {
    const prefetchedSlices =
      get(url).value?.state?.[ODOSCOPE_ROUTE_SLICE_PAYLOAD_KEY]

    if (!prefetchedSlices || typeof prefetchedSlices !== 'object') {
      return
    }

    const currentSlices =
      nuxtApp.payload.state[ODOSCOPE_ROUTE_SLICE_PAYLOAD_KEY]

    if (!currentSlices || typeof currentSlices !== 'object') {
      nuxtApp.payload.state[ODOSCOPE_ROUTE_SLICE_PAYLOAD_KEY] = prefetchedSlices
      return
    }

    Object.assign(currentSlices, prefetchedSlices)
  }

  nuxtApp.hook('link:prefetch', async (url: string) => {
    try {
      if (!has(url) && showPerformanceModule.value) {
        await prefetch(url)
      }
    } catch {
      // no-op
    }
  })

  const router = useRouter()
  router.beforeEach((to, _from, next) => {
    if (has(to.fullPath)) {
      mergePrefetchedOdoscopeSlices(to.fullPath)
      hydrateNuxtCaches(to.fullPath)
    }
    next()
  })
})
